'use client';

import { DetailsHeader } from '@/modules/league/details/components/DetailsHeader';
import { DetailsSidebar } from '@/modules/league/details/components/DetailsSidebar';
import { DetailsHeaderData } from '@/modules/league/new-components/types';
import { Session } from '@/types/types';

interface DetailsHeaderWrapperProps {
  header: DetailsHeaderData;
  params: { slug: string; sessionId: string };
  showSponsors: boolean;
  isAuthorized: boolean;
  isSuperAdmin: boolean;
  user?: Session;
}

export function DetailsHeaderWrapper({
  header,
  params,
  showSponsors,
  isAuthorized,
  isSuperAdmin,
  user,
}: DetailsHeaderWrapperProps) {
  return (
    <>
      <div className='flex flex-col lg:container lg:px-0 lg:w-2/3'>
        <DetailsHeader
          details={header.details}
          session={header.session}
          gameDay={header.gameDay}
          isRegistered={header.isRegistered === 1}
          location={header.locationInfo.locationInfo}
          params={params}
          showSponsors={showSponsors}
          user={user}
        />
        <div className='flex flex-col lg:hidden'>
          <DetailsSidebar
            details={header.details}
            session={header.session}
            clubMember={header.clubMember}
            isRegistered={header.isRegistered === 1}
            params={params}
            showSponsors={showSponsors}
            isAuthorized={isAuthorized}
            isSuperAdmin={isSuperAdmin}
            user={user}
          />
        </div>
      </div>
      <div className='hidden flex-col py-4 lg:flex lg:w-1/3 pl-2'>
        <DetailsSidebar
          details={header.details}
          session={header.session}
          clubMember={header.clubMember}
          isRegistered={header.isRegistered === 1}
          params={params}
          showSponsors={showSponsors}
          isAuthorized={isAuthorized}
          isSuperAdmin={isSuperAdmin}
          user={user}
        />
      </div>
    </>
  );
}
